export const COMPACT_LOG_GROUPS = [
  { key: 'vehicle', label: '车辆 / 设备', share: 17, props: ['Vin', 'Sn', 'SnType'] },
  { key: 'software', label: '软件信息', share: 9, props: ['DiagId', 'Version', 'ProductType', 'Language'] },
  { key: 'request', label: '请求参数', share: 20, props: ['DiagParam'] },
  { key: 'response', label: '响应数据', share: 20, props: ['ResData'] },
  { key: 'time', label: '时间 / 执行', share: 13, props: ['CreatedAt', 'FuncType', 'runtime'] },
  { key: 'network', label: '网络信息', share: 21, props: ['Ip', 'WifiName', 'LocalMac', 'WifiMac'] },
];

export function logFieldText(value) {
  return value === null || value === undefined || value === '' ? '-' : String(value);
}

// 只拆分显示，不解析时区或截断原始时间精度。
export function splitLogTimestamp(value) {
  const text = logFieldText(value);
  const match = text.match(/^(\d{4}-\d{2}-\d{2})[ T](.+)$/);
  return match ? [match[1], match[2]] : [text];
}

export function getCompactLogGroups(columns) {
  const visible = new Set(columns.map(column => column.prop));
  return COMPACT_LOG_GROUPS.filter(group => group.props.some(prop => visible.has(prop)));
}

// 仅调整 JSON 的空白，保留大整数、转义字符和原始字段顺序。
export function formatLogDetail(value, prop, mode = 'formatted') {
  const raw = value === null || value === undefined ? '' : String(value);
  if (mode === 'raw') return raw;
  const match = prop === 'DiagParam' ? raw.match(/^(sm2|pro):(.*)$/s) : null;
  const prefix = match ? `${match[1]}:` : '';
  const content = (match ? match[2] : raw).trim();
  try { JSON.parse(content); } catch { return raw; }
  let depth = 0;
  let quoted = false;
  let escaped = false;
  let result = '';
  const indent = () => '  '.repeat(depth);
  for (let i = 0; i < content.length; i++) {
    const char = content[i];
    if (quoted) {
      result += char;
      if (escaped) escaped = false;
      else if (char === '\\') escaped = true;
      else if (char === '"') quoted = false;
      continue;
    }
    if (char === '"') { quoted = true; result += char; }
    else if (char === '{' || char === '[') {
      result += char;
      let nextIndex = i + 1;
      while (/\s/.test(content[nextIndex] || '') && nextIndex < content.length) nextIndex++;
      const next = content[nextIndex];
      if (next === (char === '{' ? '}' : ']')) continue;
      depth++;
      result += `\n${indent()}`;
    } else if (char === '}' || char === ']') {
      let previousIndex = i - 1;
      while (previousIndex >= 0 && /\s/.test(content[previousIndex])) previousIndex--;
      const previous = content[previousIndex];
      if (previous !== (char === '}' ? '{' : '[')) {
        depth--;
        result += `\n${indent()}`;
      }
      result += char;
    } else if (char === ',') result += `,\n${indent()}`;
    else if (char === ':') result += ': ';
    else if (!/\s/.test(char)) result += char;
  }
  return prefix ? `${prefix}\n${result}` : result;
}
